import React from 'react';
import { motion } from 'framer-motion';
import { Smartphone, Zap, MessageCircle, ArrowRight } from 'lucide-react';
export function SystemOverview() {
  return <section className="py-20 bg-[#1A6B5C] text-white relative overflow-hidden" data-id="element-168">
      {/* Decorative circles */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-white opacity-5 rounded-full -translate-x-1/2 -translate-y-1/2" data-id="element-169"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#D4A853] opacity-10 rounded-full translate-x-1/3 translate-y-1/3 blur-3xl" data-id="element-170"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-172">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white" data-id="element-173">
            ✅ CapCut Cashflow: Tu Nuevo Sistema
          </h2>
          <p className="text-xl text-white/80 font-medium" data-id="element-174">
            Simple. Gratis. Desde tu celular.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-175">
          {/* Feature 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0
        }} className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20 hover:bg-white/15 transition-colors" data-id="element-176">
            <div className="w-14 h-14 bg-white text-[#1A6B5C] rounded-full flex items-center justify-center mb-6 shadow-lg" data-id="element-177">
              <Smartphone className="w-7 h-7" data-id="element-178" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-179">CapCut GRATIS (móvil)</h3>
            <p className="text-white/80 leading-relaxed" data-id="element-180">
              App profesional sin costo. Sin watermark. 1080p. Todo lo que
              necesitas en tu bolsillo.
            </p>
          </motion.div>

          {/* Feature 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20 hover:bg-white/15 transition-colors" data-id="element-181">
            <div className="w-14 h-14 bg-[#E8614D] text-white rounded-full flex items-center justify-center mb-6 shadow-lg" data-id="element-182">
              <Zap className="w-7 h-7" data-id="element-183" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-184">Prompts LatinoBoost</h3>
            <p className="text-white/80 leading-relaxed" data-id="element-185">
              Copy-paste bilingüe. Convierte 1 video de 2min en 15 Reels virales
              automáticamente.
            </p>
          </motion.div>

          {/* Feature 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20 hover:bg-white/15 transition-colors" data-id="element-186">
            <div className="w-14 h-14 bg-[#D4A853] text-white rounded-full flex items-center justify-center mb-6 shadow-lg" data-id="element-187">
              <MessageCircle className="w-7 h-7" data-id="element-188" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-189">Mensajes 3DM</h3>
            <p className="text-white/80 leading-relaxed" data-id="element-190">
              Contacta negocios latinos. Taquerías y coaches pagan $20/paquete
              por ROI inmediato.
            </p>
          </motion.div>
        </div>

        {/* Transformation Story Box */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[#D4A853] rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-191">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-10 rounded-full -mr-20 -mt-20" data-id="element-192"></div>

          <div className="flex flex-col md:flex-row items-center justify-between gap-8 relative z-10" data-id="element-193">
            <div className="flex-1" data-id="element-194">
              <h3 className="text-2xl font-bold text-[#2D1B0E] mb-4" data-id="element-195">
                La Transformación Real
              </h3>
              <p className="text-[#2D1B0E] text-lg leading-relaxed mb-0" data-id="element-196">
                "Yo pasé de{' '}
                <span className="font-bold bg-white/30 px-1 rounded" data-id="element-197">
                  $1,200/mes
                </span>{' '}
                como cajera a{' '}
                <span className="font-bold bg-white/30 px-1 rounded" data-id="element-198">
                  $2,000+
                </span>{' '}
                editando por las noches."
              </p>
            </div>
            <div className="hidden md:block w-px h-24 bg-[#2D1B0E]/20" data-id="element-199"></div>
            <div className="flex-1 text-center md:text-left" data-id="element-200">
              <p className="text-[#2D1B0E] text-xl font-bold mb-2" data-id="element-201">Tú:</p>
              <div className="flex items-center justify-center md:justify-start gap-3 text-2xl md:text-3xl font-bold text-white" data-id="element-202">
                <span data-id="element-203">Tu primer $20 en 48 horas</span>
                <ArrowRight className="w-8 h-8" data-id="element-204" />
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}